import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=46cf063b&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=46cf063b&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cf063b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46cf063b')) {
      api.createRecord('46cf063b', component.options)
    } else {
      api.reload('46cf063b', component.options)
    }
    module.hot.accept("./Roles.vue?vue&type=template&id=46cf063b&scoped=true", function () {
      api.rerender('46cf063b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/roles/Roles.vue"
export default component.exports